// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings{display:flex;flex-direction:row;overflow:hidden;background-color:var(--background)}.settings__wrapper{flex:1;display:flex;justify-content:center;flex-direction:column;align-items:left;width:100%;height:100vh}", ""]);
// Exports
module.exports = exports;
